import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:lang/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/:lang/about/',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/:lang/rooms/:room',
      name: 'rooms',
      component: () => import('./views/Rooms.vue')
    },
    { 
      path: '*', 
      component: () => import('./views/Home.vue')
    }
  ]
})
